
import { connect } from 'react-redux';
import { withParams } from '../../containers/WithParams';
import { withRouter } from 'react-router-dom';
import LoaderWrapper from '../Loader';
import './Preview.css';
import React, { useEffect, useState } from 'react';
import addPrototypeActions from '../../actions/addPrototype';
import ReviewContainer from '../ResearcherPreview/PrototypeReviewPage/ReviewContainer/ReviewContainer';
import { history } from '../../../store';
import PATHS from '../../../routes/routes-path';
import '../../containers/products/ProductDetails/details.css'
import { LOCAL_STORAGE_USER_KEY } from '../../../constants/app'

const PreviewPrototype = props => {
    const { match: { params: { productId } }, getPrototypeDetail, prototypeList } = props;
    const user = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
    const userType = JSON.parse(user).potential_user_type


    const [prototypeNumber, setPrototypeNumber] = useState(0);

    useEffect(() => {
        getPrototypeDetail(productId);
    }, [])

    const moveToPreview = previewNumber => {
        setPrototypeNumber(previewNumber);
    };

    const goToPreviewPage = () => history.push(`${PATHS.editProduct}${productId}?section=4`);

    return (

        <div className="survey-wrapper-prototype">
            {user && userType === 1 ? null :
                <div className="recent-header back-button">
                    <div className="recent-nav">
                        <h3><b>Prototype preview</b></h3>
                    </div>
                    <button onClick={goToPreviewPage}><u>back</u></button>
                </div>
            }
            {prototypeList && prototypeList.length ?
                <div>
                    <ReviewContainer linkToFile={prototypeList[prototypeNumber] && prototypeList[prototypeNumber].linkToFile} questionStatement={prototypeList[prototypeNumber] && prototypeList[prototypeNumber].questionStatement} productId={productId} />
                    <div className="lower-nav-buttons">
                        <button className="cancel-button" onClick={() => moveToPreview(prototypeNumber - 1)} disabled={prototypeNumber === 0}>
                            Previous
                        </button>
                        <button className="save-button" onClick={goToPreviewPage}>
                            Close
                        </button>
                        <button className="cancel-button" onClick={() => moveToPreview(prototypeNumber + 1)} disabled={prototypeNumber === (prototypeList.length - 1)}>
                            Next
                        </button>
                    </div>
                </div> : <div className="no-product"><h2>No prototype available for survey yet!</h2><h4>Please navigate to "<b>Review New Product</b>"  </h4></div>}
        </div>

    )
}

const mapStateToProps = state => ({
    prototypeList: state.addPrototypeReducer.prototypeList,
})

const mapDispatchToProps = dispatch => ({
    getPrototypeDetail: productId => dispatch(addPrototypeActions.getPrototypeDetail(productId)),
})

PreviewPrototype.propTypes = {
}

PreviewPrototype.defaultProps = {
    prototypeList: []
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withParams(PreviewPrototype)));
